import React from 'react';
import { useNavigate } from 'react-router-dom';
import carImage from '../../images/komunikacyjne.jpg';
import HeroSection from '../../components/HeroSection';
import OfertaCard from '../../components/OfertaCard';
import '../../style/ofertacard.css';

import GavelIcon from '@mui/icons-material/Gavel';         // OC
import SecurityIcon from '@mui/icons-material/Security';   // AC
import HealingIcon from '@mui/icons-material/Healing';     // NNW


const Komunikacyjne = () => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate('/kontakt');
  };

  const offerings = [
    {
      label: 'Ubezpieczenie OC',
      icon: <GavelIcon />,
      color: '#FF6B6B',
      description:
        'Obowiązkowe ubezpieczenie odpowiedzialności cywilnej kierowcy – chroni Cię finansowo w przypadku wyrządzenia szkód innym uczestnikom ruchu.',
    },
    {
      label: 'Auto Casco (AC)',
      icon: <SecurityIcon />,
      color: '#4ECDC4',
      description:
        'Dobrowolne ubezpieczenie auta na wypadek uszkodzenia, kradzieży, wandalizmu lub sił natury.',
    },
    {
      label: 'Ubezpieczenie NNW',
      icon: <HealingIcon />,
      color: '#FFA726',
      description:
        'Chroni kierowcę i pasażerów w przypadku trwałego uszczerbku na zdrowiu lub śmierci na skutek wypadku komunikacyjnego.',
    },
  ];

  return (
    <>
      <HeroSection
        image={carImage}
        text="Ubezpieczenia komunikacyjne – bezpieczna droga każdego dnia"
      />

      <section style={{ maxWidth: '1100px', margin: '2rem auto', padding: '0 1rem' }}>
        <h2>Ubezpieczenia komunikacyjne</h2>
        <p>
          Oferujemy kompleksowe ubezpieczenia pojazdów, dzięki którym możesz czuć się bezpiecznie
          na każdej trasie. Zabezpiecz siebie, pasażerów i auto przed niespodziewanymi sytuacjami.
        </p>

        <div
          className="oferta-buttons"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginTop: '2rem',
            gap: '1.8rem',
          }}
        >
          {offerings.map(({ label, icon, color, description }) => (
            <OfertaCard
              key={label}
              label={label}
              icon={icon}
              color={color}
              description={description}
              onClick={handleCardClick}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Komunikacyjne;
